import store from '@/store'

export default (to) => {
  if (to.fullPath.startsWith('/admin')) {
    const currentUser = store.state.profile.currentUser
    const role = (currentUser && currentUser.role) || 'guest'
    if (role !== 'admin' && role !== 'account_manager') {
      return { redirect: '/' }
    }
  }
}
